/*
 * @Description: 
 * @Date: 2025-04-27 10:38:13
 * @LastEditors: function
 * @LastEditTime: 2025-04-27 11:10:01
 * @FilePath: \base_info_web\src\settings.js
 */
module.exports = {
  title: '',
  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,
  /**
   *  @type {number} 10
   *  @description page size
   */
  pageSize: 15,
  /**
   *  @type {string}
   *  @description  RSA key 根据项目需求修改
   */
  publicKeyForLogin: '04543e5a0b62ad221a83a8033c4143ab20c678165dec743bc1bc280e194f14101bc2be4baddf27c71fb651370c6a1f1a4b4d0fb4b8d0637fac2958149ceb3d792b',
  publicKey: '34346134376164383733383735663861',
  /**
   * 屏幕中header加尾部的高度
   */
  otherHeight: 142,
  /**
   * 应用ID
   */
  clientId: process.env.VUE_APP_CLIENTID,
  /**
   * @type {Number}
   * @description 上传文件的最大限制 单位kb
   */
  fileSize: 1024 * 1024 * 100,
  fileTypeList: ['png', 'jpg', 'gif', 'pdf', 'jpeg', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'mp4', 'avi', 'rm', 'asf', 'divx', 'mpg', 'wmv', 'mkv'],
  fileLimit: 10,
  apis: '/apis',
  // 根据项目需求修改
  appCode: 'dj_production',
  frontType: 2,
  sm4Key: '750757b3aacbf1e5b3db77578ba411a2'
};
